// extracted by mini-css-extract-plugin
export default {"fontBold":"StylistList_fontBold__0D9XW"};